import { useRef, useState } from 'react'

import useClickOutside from '~/shared/hooks/useClickOutside.hook'
import { menus } from '~/donation/constants/menu.const'
import DropdownItem from '~/donation/components/DropdownMenu/DropdownItem'
import DonateLink from '~/donation/components/DonateLink'

function DropdownMenu({ children }: { children: React.ReactElement | React.ReactElement[] }): React.ReactElement {
  const [showDropdown, setShowDropdown] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const toggleShowDropdown = (): void => {
    setShowDropdown((dropdownVisibility) => !dropdownVisibility)
  }

  useClickOutside(ref, () => setShowDropdown(false))

  return (
    <div className="w-fit">
      <div className="absolute right-3.5 top-1.5 cursor-pointer p-1.5" onClick={toggleShowDropdown} ref={ref}>
        {children}
      </div>

      <ul
        className={`${
          showDropdown ? 'block' : 'hidden'
        } z-100 absolute top-12 space-y-5 py-7 w-full bg-white bg-opacity-95`}
      >
        {menus.map((menu) => (
          <DropdownItem key={menu.titleKey} menu={menu} />
        ))}
        <li className="flex justify-center">
          <DonateLink className="border font-sm font-bold text-blue-strong" />
        </li>
      </ul>
    </div>
  )
}

export default DropdownMenu
